import { format, parse } from 'date-fns'
import isEmpty from 'lodash/isEmpty'

export default function useUtils() {
  const formatProductPreorderDate = (date?: string | null) => {
    if (!date) { return '' }
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'MM.yyyy')
  }

  const getParsedAdditionalFields = (
    additionalFields: Record<string, any>,
    additionalFieldsForm: Record<string, any>,
  ) => {
    if (isEmpty(additionalFields)) {
      return {}
    }
    if (!isEmpty(additionalFieldsForm)) {
      const parsedFields: Record<string, any> = {
        ...additionalFields,
      }
      for (let key in parsedFields) {
        const options = additionalFieldsForm[key]?.options
        const matchingOption = options?.find((option) => option.value === parsedFields[key]?.value)
        if (matchingOption) {
          parsedFields[key]!.value = matchingOption.text
        }
      }
      return parsedFields
    }
    return additionalFields
  }

  return { formatProductPreorderDate, getParsedAdditionalFields }
}
